import React from "react";
import Portal from "../components/Portal";

const Upcoming = () => {
  return (
    <div className="clipping-container">
      <Portal category="popular" />
    </div>
  );
};
export default Upcoming;
